import { Grid } from '@mui/material';

import { RenderFormField, SelectItem } from '@/components';

import { CustodyActionSectionFields } from './data';

interface CustodyActionSectionProps {
  officerOptions: SelectItem[];
}

export const CustodyActionSection = ({
  officerOptions,
}: CustodyActionSectionProps) => {
  return (
    <Grid container spacing={2}>
      {CustodyActionSectionFields.map(({ grid, name, ...rest }) => (
        <Grid key={name} item {...grid}>
          <RenderFormField
            {...rest}
            name={name}
            items={name === 'officer' ? officerOptions : undefined}
            showPopupIcon={name === 'officer'}
          />
        </Grid>
      ))}
    </Grid>
  );
};
